// @flow

import * as React from 'react';
import classnames from 'classnames';
import useSheet from '../../jss';

type Props = {
  children?: React.ReactNode,
  sheet: Object,
  style?: Object,
  width?: string
};

const defaultProps = {
  children: undefined,
  style: undefined,
  width: undefined
};

function GridCol({ children, sheet: { classes }, style, width }: Props) {
  return (
    <div className={classnames(classes.outer, classes[width])} style={style}>
      <div className={classes.inner}>{children}</div>
    </div>
  );
}

GridCol.defaultProps = defaultProps;

function applyStyles(theme) {
  return {
    outer: {
      flexBasis: '100%',
      flexGrow: 0,
      flexShrink: 0,
      display: 'flex',
      minWidth: 0 // flexbox hack, prevents wrapping
    },
    inner: {
      display: 'flex',
      flexDirection: 'column',
      minWidth: 0,
      flexGrow: 1,
      width: '100%',
      [theme.mediaQuery.desktopAndUp]: {
        paddingLeft: theme.grid.gutter / 2,
        paddingRight: theme.grid.gutter / 2,
        paddingBottom: theme.grid.gutter
      }
    },
    'one-third-sm': {
      flexBasis: '33.33%'
    },
    'two-thirds-sm': {
      flexBasis: '66.66%'
    },
    [theme.mediaQuery.desktopAndUp]: {
      'one-half': {
        flexBasis: '50%'
      },
      'one-third': {
        flexBasis: '33.33%'
      },
      'two-thirds': {
        flexBasis: '66.66%'
      },
      'one-quarter': {
        flexBasis: '25%'
      },
      'three-quarters': {
        flexBasis: '75%'
      },
      'one-fifth': {
        flexBasis: '20%'
      },
      'two-fifths': {
        flexBasis: '40%'
      },
      'three-fifths': {
        flexBasis: '60%'
      },
      'four-fifths': {
        flexBasis: '80%'
      }
    }
  };
}

export default useSheet(applyStyles)(GridCol);
